import {
  FETCH_NATIONALITIES,
  START_LOADING,
  END_LOADING,
  FETCH_PROFILE,
} from "./constants";
import * as api from "../api/index.js";

export const getNationalities = () => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const { data } = await api.fetchNationalities();
    console.log('Nationalities API Response:', data);
    dispatch({ type: FETCH_NATIONALITIES, payload: data });
    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error);
  }
};
